import { requireSessionToken } from '@avantstay/auth-token'

import { REMY_API } from './remySessions'

export interface RemyOutputFile {
  id: string
  filename: string
  title?: string
  mimeType: string
  sizeBytes: number
  sha256: string
  expiresAt: string
  url: string
}

export const readRemyOutputFile = (value: unknown): RemyOutputFile | undefined => {
  if (typeof value !== 'object' || value === null) return undefined
  const file = value as Record<string, unknown>
  if (
    typeof file.id !== 'string' ||
    typeof file.filename !== 'string' ||
    typeof file.mimeType !== 'string' ||
    typeof file.sizeBytes !== 'number' ||
    typeof file.sha256 !== 'string' ||
    typeof file.expiresAt !== 'string' ||
    typeof file.url !== 'string'
  ) {
    return undefined
  }
  return {
    id: file.id,
    filename: file.filename,
    ...(typeof file.title === 'string' ? { title: file.title } : {}),
    mimeType: file.mimeType,
    sizeBytes: file.sizeBytes,
    sha256: file.sha256,
    expiresAt: file.expiresAt,
    url: file.url,
  }
}

/**
 * Download generated bytes through Remy with a fresh Clerk token. The gateway
 * rechecks account status, remy.access, ownership, expiry, size, and SHA-256.
 */
export const downloadRemyOutputFile = async (file: RemyOutputFile): Promise<void> => {
  const api = new URL(REMY_API)
  const target = new URL(file.url, api)
  if (target.origin !== api.origin || !target.pathname.startsWith('/api/remy/chat/files/')) {
    throw new Error('Remy returned an invalid file URL')
  }
  const token = await requireSessionToken()
  const response = await fetch(target.toString(), {
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!response.ok) throw new Error(`Download failed (${response.status})`)

  const objectUrl = URL.createObjectURL(await response.blob())
  const anchor = document.createElement('a')
  anchor.href = objectUrl
  anchor.download = file.filename
  anchor.click()
  // Firefox can drop the download if the URL is revoked synchronously.
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000)
}
